import tmhRequest from '@/config/tmhRequest'

export default {
  searchGiftCard: function (data) {
    return tmhRequest({
      url: '/project/tmh/giftcard/searchgiftcard',
      method: 'post',
      params: data,
    })
  },
  searchGiftCardCount: function (data) {
    return tmhRequest({
      url: '/project/tmh/giftcard/searchgiftcardcount',
      method: 'post',
      data: data,
    })
  },
  searchGiftCardByPage: function (data) {
    return tmhRequest({
      url: '/project/tmh/giftcard/searchgiftcardbypage',
      method: 'post',
      data: data,
    })
  },
  addGiftCard: function (data) {
    return tmhRequest({
      url: '/project/tmh/giftcard/addgiftcard',
      method: 'post',
      params: data,
    })
  },
  recoveryGiftCard: function (data) {
    return tmhRequest({
      url: '/project/tmh/giftcard/recoverygiftcard',
      method: 'post',
      data: data,
    })
  },
  closeGiftCard: function (data) {
    return tmhRequest({
      url: '/project/tmh/giftcard/closegiftcard',
      method: 'post',
      data: data,
    })
  },

  activeGiftCard: function (data) {
    return tmhRequest({
      url: '/project/tmh/giftcard/activegiftcard',
      method: 'post',
      params: data,
    })
  },
 adjustGiftCard: function (data) {
    return tmhRequest({
      url: '/project/tmh/giftcard/adjustgiftcard',
      method: 'post',
      params: data,
    })
  },

  repirtGiftCard: function (data) {
    return tmhRequest({
      url: '/project/tmh/giftcard/repairgiftcard',
      method: 'post',
      params: data,
    })
  },
}


// WEBPACK FOOTER //
// ./src/api/tmh/item/giftcard.js